var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 6.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-1.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM19.5 17.25c0 2.485-3.358 4.5-7.5 4.5-4.142 0-7.5-2.015-7.5-4.5s3.358-4.5 7.5-4.5c4.142 0 7.5 2.015 7.5 4.5Zm-1.5 0c0 .509-.352 1.226-1.468 1.896-1.088.652-2.686 1.104-4.532 1.104s-3.445-.452-4.532-1.104C6.352 18.476 6 17.759 6 17.25c0-.509.352-1.226 1.468-1.896 1.087-.652 2.686-1.104 4.532-1.104s3.444.452 4.532 1.104c1.116.67 1.468 1.387 1.468 1.896Z"
  })));
};
export default SvgUser;